import { render } from "./Faq.vue?vue&type=template&id=7bb1cc06"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
script.render = render

export default script